import React, { useState } from "react";
import style from "./create-clone.module.css";
import axios from "axios"; 
import { apiURL } from "../../../../../../config/default";
import { useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateClone = ({productInfo,refershData}) => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const [cloneState, setCloneState] = useState({
    prefix: productInfo.prefix,
    brandName: productInfo.brandName,
    couponCode: productInfo.couponCode,
    discountValue : productInfo.discountValue,
    discountType: productInfo.discountType,
    lowPriceSalePercentage: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setCloneState((prev) => ({ ...prev, [name]: value }));
  };

  //api for creating clone which will send productinfo._id and cloneState to backend
  const createClone = () => {
    //if cloneState.lowPriceSalePercentage is empty then api call will not be made
    if (!cloneState.lowPriceSalePercentage || !cloneState.discountType) {
      toast.error("Please enter value or select discount type", { containerId: "B" });
      return;
    }

    //api call
    axios.post(`${apiURL}admin/crawler-clone`, {
      scrapDetailId: productInfo._id,
      cloneState,
    })
    .then((response) => {
      console.log(response, response.status, response.statusText);
      //if response is success then redirect to discount-code page
      if (response.status === 200) {
        refershData();
      }
    })
    .catch((error) => {
      //show toast message if api call fails
      toast.error(error.message, { containerId: "B" });
      console.log(error);
    });
  };


  return (
    <>
     <ToastContainer
     stacked 
          enableMultiContainer
          containerId={"B"}
          // position={toast.POSITION.TOP_RIGHT}
          position="top-right" // Hardcoded position
        />
      <div className={style.cloneHeading}>
        <h2 className={style.cloneTitle}>Create Clone</h2>
      </div>
      <div className={style.cloneContainer}>
        <div className={style.discountDetail}>
          <p>Enter Discount Details:</p>
          <p>[{cloneState.brandName}]_[{cloneState.couponCode}]_[{cloneState.discountType === '$' ? cloneState.discountType + cloneState.lowPriceSalePercentage : cloneState.lowPriceSalePercentage + cloneState.discountType}] {cloneState.lowPriceSalePercentage ? 'OFF' : ''}</p>
        </div>
        <div className={style.inputBox}>
          <div className={style.inputContainer}>
            <input
              className={style.decorInput}
              type="text"
              name="brandName"
              value={cloneState.brandName}
              // onChange={handleChange}
              placeholder="Brand Name"
            />
          </div>
          <div className={style.inputContainer}>
            <input
              className={style.decorInput}
              type="text"
              name="couponCode"
              value={cloneState.couponCode || ""}
              // onChange={handleChange}
              placeholder="coupon code"
            />
          </div>
        </div>
        <p className={style.discountType}>Select Discount Type:</p>
        <div className={style.checkBoxes}>
          {/* Discount type options */}
          <div className={style.checkBoxesInput}>
            <div className={style.inputRadio}>
              <input
                // className={style.inputRadio}
                type="radio"
                id="percent"
                name="discountType"
                value='%'
                checked={cloneState.discountType === "%"}
                onChange={handleChange}
              />
              <label htmlFor="percent">Percent Off(%)</label>
            </div>
            <div className={style.inputRadio}>
              <input
                type="radio"
                id="dollar"
                name="discountType"
                value='$'
                checked={cloneState.discountType === "$"}
                onChange={handleChange}
              />
              <label htmlFor="dollar">Dollar Off($)</label>
            </div>
          </div>

          <div className={style.discountEnterValue}>
            <p>DiscounValue:</p>
            <p>If percent enter as whole number (for 25% off enter 25)</p>
            <p>If dollar value enter full amount (for $100 off enter 100)</p>
          </div>
          <div className={style.inputValue}>
            <input
              style={{ marginBottom: ".5rem" }}
              className={style.decorInput}
              type="number"
              name="lowPriceSalePercentage"
              value={cloneState.lowPriceSalePercentage}
              onChange={handleChange}
              placeholder="Enter Value"
            />
          </div>
        </div>
      </div>
      <div className={style.linkButtonDiv}>
        <button onClick={()=> createClone()} className={style.linkButton}>Create Discount ID Clone</button>
      </div>
    </>
  );
};

export default CreateClone;
